import { c as _c } from "react/compiler-runtime";
import type { FC, SVGProps } from "react";
export const DragHandleIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(9);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>Drag Handle</title>;
    t1 = <circle cx="7.5" cy="5.5" r="1.5" fill="currentColor" />;
    t2 = <circle cx="12.5" cy="5.5" r="1.5" fill="currentColor" />;
    t3 = <circle cx="7.5" cy="10" r="1.5" fill="currentColor" />;
    t4 = <circle cx="12.5" cy="10" r="1.5" fill="currentColor" />;
    t5 = <circle cx="7.5" cy="14.5" r="1.5" fill="currentColor" />;
    t6 = <circle cx="12.5" cy="14.5" r="1.5" fill="currentColor" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== props) {
    t7 = <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}{t2}{t3}{t4}{t5}{t6}</svg>;
    $[7] = props;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
};